import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
// -
import RouteAssetCard from "site-apps/distribution/route/RouteAssetCard";
import RouteWaypointCard from "site-apps/distribution/route/RouteWaypointCard";

const PrevRoutes = ({ showPreview, item }) => {
    const { t: tT } = useTranslation("tables")
    const { t: tR } = useTranslation("routes")
    const [waypoints, setWaypoints] = useState([])


    useEffect(() => {
        setWaypoints([...item.checkpoints])
    }, [item])

    return (
        <div className={`col preview-row ${showPreview ? "" : "d-none"}`}
            style={{ width: "300px", maxWidth: "300px" }}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{ width: "300px" }}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon="fa-location-dot" />
                            </div>
                            <div className="preview-title">
                                <label>{tT("containers.name")}</label>
                                <div>{item.name}</div>
                            </div>
                        </div>
                        <div className="preview-item">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className="text-center">{tR("labels.containers")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        waypoints.length
                                            ? waypoints.map((_item, index) => (
                                                <tr key={index} data-idx={index}>
                                                    <td>
                                                        {
                                                            _item.is_asset
                                                                ? <RouteAssetCard asset={_item} />
                                                                : <RouteWaypointCard routeway={_item} />
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                            : <></>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrevRoutes

